// src/components/common/ui/Spinner.js
import React from 'react';

/**
 * Spinner de carga reutilizable. Sustituye a las decenas de <div> con
 * `animate-spin` repartidos por los componentes.
 *
 * @param {'xs'|'sm'|'md'|'lg'} size
 * @param {'primary'|'white'|'emerald'|'slate'} tono
 */
const TAMANOS = {
    xs: 'w-4 h-4 border-2',
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-10 h-10 border-4'
};

const TONOS = {
    primary: 'border-clinica-primary border-t-transparent',
    white: 'border-white/30 border-t-white',
    emerald: 'border-emerald-500 border-t-transparent',
    slate: 'border-slate-200 border-t-slate-600'
};

export default function Spinner({ size = 'md', tono = 'primary', className = '' }) {
    return (
        <div className={`${TAMANOS[size] || TAMANOS.md} ${TONOS[tono] || TONOS.primary} rounded-full animate-spin ${className}`} />
    );
}
